import { Container, Row, Col } from 'react-bootstrap'
import './footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="shopwave-footer">
      <Container>
        <Row className="align-items-center">
          <Col className="text-center py-4">
            <p className="footer-text">
              ShopWave &copy; {currentYear} Suvigya Mishra · Crafted for better carts
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}

export default Footer
